import { render } from "./FilePicker.vue?vue&type=template&id=3d384d72"
import script from "./FilePicker.vue?vue&type=script&lang=js"
export * from "./FilePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__